import React from 'react';
import ExhibitionSwiper from './ExhibitionSwiper';
import '../../css/exhibition.css';
import { isMobile } from 'react-device-detect';
const Exhibition = () => {
  return (
    <div className={isMobile ? 'p_container1224' : 'p_container'}>
      <div className="m_month_event">
        <div className="product_title">
          <h2>오리지널 굿즈</h2>
        </div>
        <ExhibitionSwiper id={'main-exhibition'} />
      </div>
    </div>
  );
};

export default Exhibition;
